import React from 'react'

const NurseDashboard = () => {
	return (
		<div>NurseDashboard</div>
	)
}

export default NurseDashboard